module.exports = __webpack_public_path__ + "img/title.de470698.png";